import { render, staticRenderFns } from "./SingleJournalKeyNumberRow.vue?vue&type=template&id=3c8d54c2&scoped=true&"
import script from "./SingleJournalKeyNumberRow.vue?vue&type=script&lang=js&"
export * from "./SingleJournalKeyNumberRow.vue?vue&type=script&lang=js&"
import style0 from "./SingleJournalKeyNumberRow.vue?vue&type=style&index=0&id=3c8d54c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d54c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSpacer,VTooltip})
